// @flow
import React from 'react';
import moment from 'moment';
import DocumentTitle from 'react-document-title';
import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import TableLayout from '../../components/TableLayout';
import useBaseTableProps from '../../hooks/useBaseTableProps';
import useIntl from '../../hooks/useIntl';
import { useVarianceReport } from './hooks';
import { useHeaders, useRows } from './hooks.useRows';
import GlDetailModal from './GlDetailModal';
import messages from './messages';

const NAME = 'variance-report';

const VarianceReport = () => {
  const intl = useIntl();
  const baseTableProps = useBaseTableProps();
  const report = useVarianceReport();
  const headers = useHeaders();
  const rows = useRows(report);

  const monthPicker = (
    <DatePicker
      label={intl.formatMessage(messages.month)}
      openTo="month"
      views={['year', 'month']}
      disableFuture
      value={moment(report.month, 'YYYY-MM')}
      onChange={report.onMonthChange}
    />
  );

  return (
    <DocumentTitle title={report.title}>
      <Box data-testid={NAME}>
        {!report.isPropertySelected ? (
          <Typography variant="bodyMedium" sx={{ color: 'text.secondary' }}>
            {intl.formatMessage(messages.selectPropertyPrompt)}
          </Typography>
        ) : (
          <TableLayout name={NAME}>
            {(tableHeight) => (
              <>
                <TableHeader
                  title={report.title}
                  subtitle={report.subtitle}
                  actions={monthPicker}
                />
                {report.error ? (
                  <Typography
                    role="alert"
                    variant="bodyMedium"
                    sx={{ color: 'error.main', display: 'block', p: 2 }}
                  >
                    {report.error}
                  </Typography>
                ) : (
                  <Table
                    {...baseTableProps}
                    name={NAME}
                    headers={headers}
                    rows={rows}
                    height={tableHeight}
                    isLoading={report.isLoading}
                    count={rows.length}
                    totalCount={rows.length}
                    showSettings={false}
                    emptyStateMessage={intl.formatMessage(messages.empty)}
                  />
                )}
              </>
            )}
          </TableLayout>
        )}
        <GlDetailModal
          month={report.month}
          drillDown={report.drillDown}
          onClose={report.onCloseDrillDown}
        />
      </Box>
    </DocumentTitle>
  );
};

export default VarianceReport;
